import { TimeBucket_TimeSeries } from "../proto/generated/common";
import { SuperChartConfiguration_TimeBucket } from "../proto/generated/superchart-page";

const IST_OFFSET = 19800;
const monthNames = [
    'January', 'February', 'March', 'April',
    'May', 'June', 'July', 'August',
    'September', 'October', 'November', 'December'
];

export enum TimeZone {
    IST,
    UTC
}

const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

export function utcToIST(timeInSeconds: number) {
    return timeInSeconds + IST_OFFSET;
}

export function istToUTC(timeInSeconds: number) {
    return timeInSeconds - IST_OFFSET;
}
export function convertToTimezone(time: number, timezone: TimeZone) {
    switch (timezone) {
        case TimeZone.IST:
            return utcToIST(time);
        case TimeZone.UTC:
            return time;
    }
}

export function convertToTimeZone(time: number, timeZone: TimeZone) {
    switch (timeZone) {
        case TimeZone.IST:
            return utcToIST(time);
        case TimeZone.UTC:
            return time;
    }
}

export function convertFromUTC(time: number, timeZone: TimeZone): number {

    switch (timeZone) {
        case TimeZone.IST:
            return istToUTC(time);
    }
    return 0
}

export function convertToUTC(time: number, timeZone: TimeZone): number {
    switch (timeZone) {
        case TimeZone.IST:
            return istToUTC(time);
        case TimeZone.UTC:
            return time;
    }
}

export function getMonthName(index: number): string {
    if (index < 0 || index > 11) {
        console.log("Error getting month name from index");
        return "";
    }
    return monthNames[index];
}

export function formatTimestamp(timestamp: string) {
    const date = new Date(timestamp);

    return `${months[date.getMonth()]} ${date.getDate()}, ` +
        `${('0' + date.getHours()).slice(-2)}:${('0' + date.getMinutes()).slice(-2)}:${('0' + date.getSeconds()).slice(-2)}`;
}

export function formatUnixTimestamp(unixTimestamp: number, showTimeOnly = false) {
    let date = new Date(unixTimestamp);
    let month = months[date.getMonth()];
    let day = date.getDate();
    let year = date.getFullYear();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();

    let formatMinutes = (minutes < 10 ? '0' : '') + minutes;
    let formatSeconds = (seconds < 10 ? '0' : '') + seconds;

    if (showTimeOnly) {
        return `${hours}:${formatMinutes}:${formatSeconds}`
    }
    // Format the date and time as desired
    return `${month} ${day}, ${year} ${hours}:${formatMinutes}:${formatSeconds}`;
}

export function isUnixTimestampToday(unixTimestamp: number) {
    const date = new Date(unixTimestamp)
    const now = new Date()
    return date.getFullYear() === now.getFullYear()
        && date.getMonth() === now.getMonth()
        && date.getDate() === now.getDate()
}

export function formatUnixTimestampForOrderBook(unixTimestamp: number, timeOnly = false) {
    let date = new Date(unixTimestamp);
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let year = date.getFullYear()
    let day = date.getDate().toString().padStart(2, '0');
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    let formatMinutes = (minutes < 10 ? '0' : '') + minutes;
    let formatSeconds = (seconds < 10 ? '0' : '') + seconds;
    const time = `${hours}:${formatMinutes}:${formatSeconds}`
    if (timeOnly) return time
    return `${year}-${month}-${day} ${time}`;
}

export function formatUnixTimestampReadable(unixTimestamp: number) {
    const date = new Date(unixTimestamp)
    const now = new Date()

    const isToday = date.getDate() === now.getDate() && date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear()

    if (isToday) {
        // Show only HH:MM
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        return `${hours}:${minutes}`
    } else {
        // Example: Sat, Oct 25 01:05
        const options: Intl.DateTimeFormatOptions = {
            weekday: 'short',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }

        // Convert and clean up commas
        let formatted = date.toLocaleString('en-US', options)
        formatted = formatted
            .replace(/^(\w+)\s/, '$1, ') // Add comma after weekday
            .replace(/,(\s\d{2}:)/, '$1') // Remove comma before time

        return formatted
    }
}




export const toDayFormat = (timeInMs: number) => {
    const date = new Date(timeInMs);
    return date.toLocaleDateString();
}

export function getPreviousDay(currentDate: Date, daysBefore = 0, monthsBefore = 0): Date {
    const date = new Date(currentDate)
    date.setDate(date.getDate() - daysBefore)
    date.setMonth(date.getMonth() - monthsBefore)
    return date
}
export function formatEpochTime(time: number) {
    const date = new Date(time);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
}

function getMonthIndex(monthString: string) {
    const monthNames = [
        "JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
    ];
    return monthNames.indexOf(monthString.toUpperCase());
}

export function toDayStart(timeInMilliSeconds: number) {
    const date = new Date(timeInMilliSeconds);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
}

export function getTimeGap(timeBucket: SuperChartConfiguration_TimeBucket): number {
    switch (timeBucket?.timeSeries) {
        case TimeBucket_TimeSeries.DAY: return timeBucket.timeValue * 24 * 60 * 60
        case TimeBucket_TimeSeries.HOUR: return timeBucket.timeValue * 60 * 60
        case TimeBucket_TimeSeries.MINUTE: return timeBucket.timeValue * 60
        case TimeBucket_TimeSeries.SECOND: return timeBucket.timeValue
        case TimeBucket_TimeSeries.WEEK: return timeBucket.timeValue * 7 * 24 * 60 * 60
        case TimeBucket_TimeSeries.MONTH: return timeBucket.timeValue * 30 * 24 * 60 * 60
        case TimeBucket_TimeSeries.YEAR: return timeBucket.timeValue * 365 * 24 * 60 * 60
    }
    return 1
}

export const getDisplayDate = (time: number | undefined): string => {
    if (!time) {
        return '-'
    }
    return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    }).format(new Date(time));
}

export const getDisplayDateTime = (time: number | undefined): string => {
    if (!time) return '-';

    const date = new Date(time);
    const now = new Date();

    const sameYear = date.getFullYear() === now.getFullYear();

    return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        ...(sameYear ? {} : { year: 'numeric' }), // add year only if different
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    }).format(date);
}

export function parseYYYYMMDDDate(dateString: string) {
    if (!dateString || !dateString.match(/^\d{8}$/)) {
        return null; // Handle invalid format
    }
    const year = parseInt(dateString.substring(0, 4));
    const month = parseInt(dateString.substring(4, 6)) - 1; // Adjust for zero-based month
    const day = parseInt(dateString.substring(6, 8));
    return new Date(year, month, day);
}

export function parseDDMMMyyDate(dateString: string) {
    if (!dateString || !dateString.match(/^\d{2}[A-Z]{3}\d{2}$/)) {
        return null; // Handle invalid format
    }

    const day = parseInt(dateString.substring(0, 2));
    const month = getMonthIndex(dateString.substring(2, 5));
    const year = parseInt("20" + dateString.substring(5, 7));

    return new Date(year, month, day);
}



export const isWeekend = (date: Date): boolean => {
    if (!date) return false
    return [6, 0].includes(date.getDay())
}

export const compareDates = (d1: Date, d2: Date): number => {
    const date1 = new Date(d1)
    const date2 = new Date(d2)

    date1.setHours(0, 0, 0, 0)
    date2.setHours(0, 0, 0, 0)

    if (date1.getTime() == date2.getTime()) return 0
    if (date1.getTime() < date2.getTime()) return -1
    if (date1.getTime() > date2.getTime()) return 1

    return 0
}

export const getTimeInSeconds = (date: Date): number => {
    return (3600 * date.getHours()) + (60 * date.getMinutes()) + date.getSeconds()
}

export function isSameDate(timestamp1: number | string | Date, timestamp2: number | string | Date): boolean {
    const date1 = new Date(timestamp1);
    const date2 = new Date(timestamp2);

    return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() && // 0-indexed: Jan = 0
        date1.getDate() === date2.getDate()
    );
}

export function isFirstDateGreatedThanSecond(timestamp1: number | string | Date, timestamp2: number | string | Date): boolean {
    const date1 = new Date(timestamp1);
    const date2 = new Date(timestamp2);

    date1.setHours(0, 0, 0, 0);
    date2.setHours(0, 0, 0, 0);

    return date1 > date2
}